module.exports = __webpack_public_path__ + "img/af.db38b6dd.png";